/*********************************************
 * 
 *  All relevant code to connect to the API
 * 
 *  No other part of the code will access the http API. This way, all URLs are collected
 *  and abstracted out in this module.
 * 
 * The API should provide the following
 * GET /                   get info about the logged in user
 * GET /login?url=[URL]    force touchstone authenticatin and then redirect to [URL]
 * 
 */

import http from "@/api/http-common";
import httpAccessCode from "@/api/http-accesscode";

//import store from "@/support/mainstore.js";

var dataload = {};

/*function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}*/

dataload.getData = async function (eventname) {
    let result = { error: true }
    try {
        result = await http.get("/signup/" + eventname)
        result = result.data
    } catch (ex) {
        //console.log(ex)
        result = { error: true }
    }
    return result
    /*
    
        await sleep(2000)
        return {
            iap: {
                name: "Fab.nano IAP Event",
                description: "As you register, you will need to submit the image you want to print. You can change the image up to 24-hrs before the event. After that, you won't be able to change sessions or edit the upload.",
                confirmation: "Please be on time, as we will be inside the lab and cannot accommodate late arrivals.  If you need to change sessions or cancel, you can come back to this site up to 24-hrs before your current session.  After that, we cannot make changes (because we generate the design files at that point).",
                max_slots: 1,
                attachments: "png,jpg",
                deadline: { value: 24, units: "hours" },
                sessions: [
                    { id: 0, name: "Session 1", start: "12/5/24 2pm", duration: "2 hours", capacity: 16, current: 12, location: "12-3005" },
                    { id: 2, name: "Session 3", start: "1/14/25 2pm", duration: "2 hours", capacity: 16, current: 16, location: "12-3005" },
                    { id: 3, name: "Session 4", start: "1/14/25 5pm", duration: "2 hours", capacity: 16, current: 16, location: "12-3005" },
                    { id: 4, name: "Session 2", start: "1/13/25 2pm", duration: "2 hours", capacity: 16, current: 5, location: "12-3005" },
                    { id: 1, name: "Session 5", start: "1/20/25 2pm", duration: "2 hours", capacity: 16, current: 1, location: "12-3005" },
                    { id: 5, name: "Session 6", start: "1/30/25 5pm", duration: "2 hours", capacity: 16, current: 0, location: "12-3005" },
                ]
            }
        }*/
}

dataload.sendDataForUpload = async function (eventname, formdata) {
    var url = "/signup/" + eventname
    return (await http.post(url, formdata, { headers: { "Content-Type": "multipart/form-data" } })).data;
}
dataload.sendCancellation = async function (eventname) {
    let result = { error: true }
    try {
        result = await http.get("/signup/" + eventname + "/cancel")
        result = result.data
    } catch (ex) {
        console.log(ex)
        result = { error: true }
    }
    return result
}

dataload.sendCancellationUsingAccessCode = async function (username, accesscode) {
    let result = { error: true }
    try {
        console.log(username)
        console.log(accesscode)
        let sURL = "/" + username + "/iap/" + accesscode
        console.log(sURL)
        
        result = await httpAccessCode.get(sURL, {
            accesscode: accesscode
        })
        result = result.data
        console.log(result)
    } catch (ex) {
        console.log(ex)
        result = { error: true }
    }
    return result
}





//dataload.getUserInfo = async function () {

// signed up for ID number, not entry of list
//return { username: "scholvin", events: { iap: [1] }, content: { iap: "https://news.mit.edu/sites/default/files/styles/news_article__image_gallery/public/images/202412/MIT_Methane-Conversion-01-PRESS_0.jpg?itok=i82grD_c" } }
/*    var result = undefined
    try {
        result = await http.get("/signup/" + eventname)
        result = result.data
    } catch (ex) {
        console.log(ex)
        result = { error: true }
    }
    return result*/

dataload.saveData = async function (userdata, eventname) {
    if (userdata.kerberos == undefined) return { error: true, message: "no username loaded" }
    var url = "/signup/" + eventname
    var requestParams = { kerberos: userdata.kerberos, id: userdata.id };
    return (await http.post(url, requestParams)).data;
}

export default dataload;

